let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eocq1")).then(() => parcelRequire('7hkHb'));